const UserList = ( props ) => {
	if ( props.filter == props.userFilter ) {
		return <div dangerouslySetInnerHTML={{ __html: props.content }}></div>
	}
	return "";
};

export default UserList;